<mat-card appearance="outlined" class="col-12 stretch">
  <mat-card-header>
    Living Benefits
    <button
      type="button"
      mat-button
      class="header-button download-link"
      (click)="load()"
    >
      <mat-icon>cloud_download</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content>
    <ngx-loading
      [show]="state === 'loading'"
      [config]="{ fullScreenBackdrop: false }"
    />
    @if (state === 'loaded' || state === 'none') {
      <button
        type="button"
        mat-button
        class="header-button download-link"
        (click)="download()"
      >
        <mat-icon>save</mat-icon>
      </button>
    }
    @if (state === 'none') {
      <div class="no-results">
        <h4>No Annuities Available</h4>
      </div>
    }
    @if (state === 'error') {
      <strong>Error Loading Rates</strong>
    }
    @if (updating) {
      <table>
        <thead>
          <th>Carrier</th>
          <th>Carrier Code</th>
          <th>Product Code</th>
          <th>Modifier</th>
          <th>VersionDate</th>
          <th>Name</th>
          <th>Basis Cost</th>
          <th>Benefit Base Increase Percent</th>
          <th>Deferral Bonus Length</th>
          <th>Age Min</th>
          <th>Age Max</th>
          <th>Calculation</th>
          <th>Age Bands</th>
          <th>Premium Min</th>
          <th>Premium Max</th>
          <th>ActiveDate</th>
          <th>Deprecate Date</th>
        </thead>
        <tbody>
          @for (a of updating; track a) {
            <tr
              [className]="
                GetClass(a['RateEffectiveDate'], a['RateDeprecateDate'])
              "
            >
              <td>{{ a['Carrier'] }}</td>
              <td>{{ a['CarrierCode'] }}</td>
              <td>{{ a['ProductCode'] }}</td>
              <td>{{ a['Modifier'] }}</td>
              <td>{{ a['VersionDate'] }}</td>
              <td>{{ a['Name'] }}</td>
              <td>{{ a['BasisCost'] }}</td>
              <td>{{ a['BenefitBaseIncreasePercent'] }}</td>
              <td>{{ a['DeferralBonusLength'] }}</td>
              <td>{{ a['AgeMin'] }}</td>
              <td>{{ a['AgeMax'] }}</td>
              <td>{{ a['Calculation'] }}</td>
              <td>{{ a['AgeBands'] }}</td>
              <td>{{ a['PremMin'] }}</td>
              <td>{{ a['PremMax'] }}</td>
              <td>{{ a['ActiveDate'] }}</td>
              <td>{{ a['DeprecateDate'] }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </mat-card-content>
</mat-card>
